import { Constant, SERVER_URL } from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class TenantService {
    constructor() {
        this.baseURL = 'tenant';
    }

    async _fetchTenant(includeAuth) {
        if (Constant.TENANT == null) {
            const headers = { 'Content-Type': 'application/json' };
            if (includeAuth) {
                headers['Authorization'] = localStorage.getItem("Authorization");
            }
            try {
                const response = await fetch(SERVER_URL + this.baseURL + '/getTenant', {
                    headers
                });
                Constant.TENANT = await response.json();
            } catch (error) {
                GeneralUtils.notification(error);
            }
        }
    
        return Constant.TENANT;
    }
    
    async getTenant() {
        return this._fetchTenant(true);
    }
    
    async getTenantWithoutLogin() {
        return this._fetchTenant(false);
    }
}